// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__jR1hZ","bannerBackground":"Banner_bannerBackground__nTwX+"};